const firebaseConfig = {
    apiKey: "AIzaSyAlOrOacMNjUi9SN1EJ_yiQ7T8cPW8HA0M",
    authDomain: "holidays-fantacy-as-11.firebaseapp.com",
    projectId: "holidays-fantacy-as-11",
    storageBucket: "holidays-fantacy-as-11.appspot.com",
    messagingSenderId: "205939766778",
    appId: "1:205939766778:web:9e9d5b7d9756c8030ae043"
};

export default firebaseConfig;